import type { FormPage } from "../../types/form.types";

export interface AddTarget {
  pageIndex: number;
  pageId: string;
  sectionId: string;
}

export function resolveAddTarget(
  pages: FormPage[],
  currentPageIndex: number,
  selectedSectionId: string | null,
): AddTarget | null {
  if (selectedSectionId) {
    for (let pageIndex = 0; pageIndex < pages.length; pageIndex++) {
      const page = pages[pageIndex];
      if (page.sections.some((s) => s.id === selectedSectionId)) {
        return { pageIndex, pageId: page.id, sectionId: selectedSectionId };
      }
    }
  }
  const page = pages[currentPageIndex];
  const last = page?.sections[page.sections.length - 1];
  return page && last ? { pageIndex: currentPageIndex, pageId: page.id, sectionId: last.id } : null;
}
